import { render, staticRenderFns } from "./vacancy.vue?vue&type=template&id=282d4444&scoped=true&"
import script from "./vacancy.vue?vue&type=script&lang=js&"
export * from "./vacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d4444",
  null
  
)

export default component.exports